import React, { Component } from "react";

import URL from "../../config/api";
import axios from "../../config/axios";
import { ehVisualizacaoTrilha, TrilhaDeAtividade } from "../TrilhaLudica";
import Widgets from "../Widgets/Widgets";

/**
 * Escolhe COMO os itens da atividade são apresentados ao aluno: lista clássica
 * (<Widgets>) ou trilha lúdica (<TrilhaLudica>).
 *
 * Existe como componente próprio por quatro motivos:
 * 1. mantém o diff na página Do (1761 linhas, sem testes) em poucas linhas;
 * 2. deixa a decisão testável sem montar o Do inteiro, que tem socket, Redux,
 *    axios e acesso direto ao DOM;
 * 3. é o error boundary: se a trilha quebrar, o aluno cai na lista e consegue
 *    fazer a atividade de qualquer jeito. Uma feature de apresentação nunca
 *    pode impedir a atividade;
 * 4. é onde o HTTP da trilha pode morar. O módulo `TrilhaLudica` é autocontido
 *    e nenhum import sai dele — ele monta o corpo do POST e entrega aqui, e é
 *    esta ponte que conhece `config/api` e `config/axios`. Sem isso o módulo
 *    arrastaria o AVA junto ao ser plugado noutro host.
 *
 * Só é usado no ramo do ALUNO. O professor continua indo direto para <Widgets>.
 */
class ItensDaAtividade extends Component {
  constructor(props) {
    super(props);
    this.state = { erroNaTrilha: false };
  }

  static getDerivedStateFromError() {
    return { erroNaTrilha: true };
  }

  componentDidCatch(erro) {
    // eslint-disable-next-line no-console
    console.error(
      "Falha ao renderizar a trilha lúdica; exibindo a lista de itens.",
      erro
    );
  }

  /**
   * Sobe o estado da trilha para o servidor.
   *
   * Dispara e esquece, de propósito: quem chama já escreveu no `localStorage`, e
   * a reconciliação da coleção é auto-corretiva — um POST perdido se conserta na
   * próxima carga da trilha. Bloquear a interface por causa disto, ou mostrar
   * erro, contrariaria a regra de que a trilha jamais impede o aluno de fazer a
   * atividade.
   *
   * Sem token não tenta: em ambiente sem sessão (teste, storybook) a trilha
   * segue valendo só com o navegador.
   */
  sincronizarTrilha = corpo => {
    const { token } = this.props;
    if (!token) return;

    axios
      .post(`${URL.api}activity/ludic-trail/experience`, corpo, {
        headers: { authorization: `Bearer ${token}` }
      })
      .catch(erro => {
        // Silencioso para o ALUNO — nada na tela, nada bloqueado —, mas visível
        // no console de quem estiver testando.
        //
        // O silêncio total custou uma sessão de depuração: com o backend ainda
        // não publicado, as rotas respondiam 404, este catch engolia, e o
        // sintoma na tela era só "a trilha esqueceu o explorador". Nenhum sinal
        // de que havia uma requisição falhando.
        const status = erro && erro.response && erro.response.status;
        // eslint-disable-next-line no-console
        console.warn(
          `Trilha lúdica: não foi possível salvar no servidor${
            status ? ` (HTTP ${status}` : " ("
          }${
            status === 404
              ? " — a rota não existe; o backend desta feature não está publicado"
              : ""
          }). O progresso continua valendo neste navegador.`
        );
      });
  };

  render() {
    const { activity, itens, late, location, openItem, userId } = this.props;

    const modoTrilha =
      !this.state.erroNaTrilha && ehVisualizacaoTrilha(activity, location);

    if (modoTrilha) {
      return (
        <TrilhaDeAtividade
          activity={activity}
          itens={itens}
          onAbrirItem={openItem}
          userId={userId}
          location={location}
          onSincronizar={this.sincronizarTrilha}
        />
      );
    }

    // Exatamente a chamada que a página Do fazia antes desta feature: com a
    // flag desligada, o caminho de código é o de sempre.
    return (
      <Widgets
        late={late}
        itens={itens}
        openItem={openItem}
        sequentialExecution={activity && activity.sequential_execution}
        completionMark
      />
    );
  }
}

export default ItensDaAtividade;
